<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="countryForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="country" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                countryForm: () => import('../forms/CountryForm'),
                country: () => import('../editViews/Country'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                ],
                itemsField: 'countries',
                editPageName: 'country',
                apiMethod: 'Countries',
                claimName: 'Countries',
                formTitle: 'Country',
                excelTitle: 'Countries',
                hasEditPage: true,
            }
        },
    };
</script>
